var _g, _g2, _image;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSustamizeLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.05282,0,0,1.05282,-5.73601,-6.69173)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(5.75363,0,0,5.05787,-57.1922,-78.1897)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.54907,0.0106548,-0.0106548,1.54907,13.5933,20.3673)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.90963,0.814951,-0.814951,0.90963,29.6717,-26.2621)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.21153,1.90246,-1.87621,1.19481,319.625,-216.157)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 43.328,
    cy: 169.672,
    r: 4.328,
    style: {
      fill: "url(#_Linear1)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.988634,1.55245,-1.53103,0.974993,270.727,-182.296)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 43.328,
    cy: 169.672,
    r: 4.328,
    style: {
      fill: "url(#_Linear2)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.902738,1.11988,-1.13803,0.917365,207.771,-168.592)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 43.328,
    cy: 169.672,
    r: 4.328,
    style: {
      fill: "url(#_Linear3)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.669204,0.876991,-0.914669,0.697955,180.004,-132.521)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 43.328,
    cy: 169.672,
    r: 4.328,
    style: {
      fill: "url(#_Linear4)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.503092,0.667033,-0.677841,0.511244,147.029,-100.716)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 43.328,
    cy: 169.672,
    r: 4.328,
    style: {
      fill: "url(#_Linear5)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.394936,0.480044,-0.487822,0.401335,119.486,-80.9646)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 43.328,
    cy: 169.672,
    r: 4.328,
    style: {
      fill: "url(#_Linear6)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.682186,1.11654,-1.11654,0.682186,31.6403,-41.6282)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.988634,1.55245,-1.53103,0.974993,270.727,-182.296)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 43.328,
    cy: 169.672,
    r: 4.328,
    style: {
      fill: "url(#_Linear7)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.902738,1.11988,-1.13803,0.917365,207.771,-168.592)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 43.328,
    cy: 169.672,
    r: 4.328,
    style: {
      fill: "url(#_Linear8)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.669204,0.876991,-0.914669,0.697955,180.004,-132.521)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 43.328,
    cy: 169.672,
    r: 4.328,
    style: {
      fill: "url(#_Linear9)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.503092,0.667033,-0.677841,0.511244,147.029,-100.716)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 43.328,
    cy: 169.672,
    r: 4.328,
    style: {
      fill: "url(#_Linear10)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.394936,0.480044,-0.487822,0.401335,119.486,-80.9646)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 43.328,
    cy: 169.672,
    r: 4.328,
    style: {
      fill: "url(#_Linear11)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.15215,0.620146,-0.620146,1.15215,19.0622,-3.91878)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.988634,1.55245,-1.53103,0.974993,270.727,-182.296)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 43.328,
    cy: 169.672,
    r: 4.328,
    style: {
      fill: "url(#_Linear12)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.902738,1.11988,-1.13803,0.917365,207.771,-168.592)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 43.328,
    cy: 169.672,
    r: 4.328,
    style: {
      fill: "url(#_Linear13)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.669204,0.876991,-0.914669,0.697955,180.004,-132.521)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 43.328,
    cy: 169.672,
    r: 4.328,
    style: {
      fill: "url(#_Linear14)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.503092,0.667033,-0.677841,0.511244,147.029,-100.716)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 43.328,
    cy: 169.672,
    r: 4.328,
    style: {
      fill: "url(#_Linear15)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.394936,0.480044,-0.487822,0.401335,119.486,-80.9646)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 43.328,
    cy: 169.672,
    r: 4.328,
    style: {
      fill: "url(#_Linear16)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.19946,0.034075,-0.034075,1.19946,-17.4077,-279.635)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.185,239.585C63.978,239.196 61.741,239 59.5,239C38.251,239 21,256.251 21,277.5C21,298.749 38.251,316 59.5,316C80.749,316 98,298.749 98,277.5C98,276.38 97.951,275.26 97.853,274.145L88.649,274.95C88.723,275.798 88.76,276.649 88.76,277.5C88.76,293.649 75.649,306.76 59.5,306.76C43.351,306.76 30.24,293.649 30.24,277.5C30.24,261.351 43.351,248.24 59.5,248.24C61.203,248.24 62.903,248.389 64.581,248.685L66.185,239.585Z",
    style: {
      fill: "rgb(250,149,29)"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.26521,-0.00870237,0.00674088,0.980037,-40.4956,-328.231)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.088,378.066L106,391.862L88.176,391.862L97.088,378.066Z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip17)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.484607,-1.05186e-18,1.5778e-18,0.625619,26.0654,325.956)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image18",
    x: 128.934,
    y: 86.871,
    width: "36.78px",
    height: "22.052px",
    transform: "matrix(0.994053,0,0,0.958795,0,0)"
  }))))))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear1",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(27.5472,18.477,-18.222,27.9326,18.0811,152.847)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(131,255,0)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "rgb(60,150,0)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(27,102,0)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear2",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(33.7579,22.6427,-22.3303,34.2301,20.9104,154.564)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(131,255,0)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "rgb(68,162,0)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    style: {
      stopColor: "rgb(39,120,0)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(27,102,0)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear3",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(39.7504,32.6678,-33.1971,39.1166,24.9586,154.253)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(131,255,0)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "rgb(60,150,0)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(27,102,0)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear4",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(52.9659,40.165,-41.8905,50.7841,27.2511,156.869)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(131,255,0)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    style: {
      stopColor: "rgb(111,226,0)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    style: {
      stopColor: "rgb(102,212,0)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    style: {
      stopColor: "rgb(85,188,0)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(27,102,0)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear5",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(70.2443,54.0421,-54.9178,69.1243,30.5671,158.811)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(131,255,0)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "rgb(60,150,0)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(27,102,0)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear6",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(91.21,76.4926,-77.7319,89.7558,35.501,161.429)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(131,255,0)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "rgb(60,150,0)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(27,102,0)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear7",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(33.7579,22.6427,-22.3303,34.2301,20.9104,154.564)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(131,255,0)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "rgb(60,150,0)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(27,102,0)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear8",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(39.7504,32.6678,-33.1971,39.1166,24.9586,154.253)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(131,255,0)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "rgb(60,150,0)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(27,102,0)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear9",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(52.9659,40.165,-41.8905,50.7841,27.2511,156.869)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(131,255,0)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "rgb(60,150,0)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(27,102,0)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear10",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(70.2443,54.0421,-54.9178,69.1243,30.5671,158.811)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(131,255,0)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "rgb(60,150,0)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(27,102,0)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear11",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(91.21,76.4926,-77.7319,89.7558,35.501,161.429)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(131,255,0)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "rgb(60,150,0)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(27,102,0)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear12",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(33.7579,22.6427,-22.3303,34.2301,20.9104,154.564)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(131,255,0)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "rgb(60,150,0)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(27,102,0)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear13",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(39.7504,32.6678,-33.1971,39.1166,24.9586,154.253)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(131,255,0)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "rgb(60,150,0)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(27,102,0)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear14",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(52.9659,40.165,-41.8905,50.7841,27.2511,156.869)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(131,255,0)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "rgb(60,150,0)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(27,102,0)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear15",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(70.2443,54.0421,-54.9178,69.1243,30.5671,158.811)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(131,255,0)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "rgb(60,150,0)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(27,102,0)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear16",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(91.21,76.4926,-77.7319,89.7558,35.501,161.429)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(131,255,0)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "rgb(60,150,0)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(27,102,0)",
      stopOpacity: 1
    }
  })), _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "_Image18",
    width: "37px",
    height: "23px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACUAAAAXCAYAAACMLIalAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAOklEQVRIie3OMQEAIAgAQaCHsSnrogUcfpPhL8Hl7nVimPodeDFFmaJMUaYoU5QpyhRlijJFmaJGpi70DgLZb4nmIAAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSustamizeLogo);
export default __webpack_public_path__ + "static/media/sustamize_Logo.5d5e32fbd4d1d6fefe999c5a950a4356.svg";
export { ForwardRef as ReactComponent };